// Generated on 2026-06-06T17:29:59.827Z
// This file contains preloaded vehicles brands data from the API
// Do not edit manually - use 'npm run generate:vehicles-brands-data' to regenerate

export const preloadedVehiclesBrands: any = [
  {
    "marca": "TOYOTA",
    "busquedas": "245612"
  },
  {
    "marca": "HONDA",
    "busquedas": "239852"
  },
  {
    "marca": "FORD",
    "busquedas": "196673"
  },
  {
    "marca": "HYUNDAI",
    "busquedas": "118627"
  },
  {
    "marca": "NISSAN",
    "busquedas": "108138"
  },
  {
    "marca": "KIA",
    "busquedas": "60298"
  },
  {
    "marca": "MITSUBISHI",
    "busquedas": "54568"
  },
  {
    "marca": "MAZDA",
    "busquedas": "34182"
  },
  {
    "marca": "CHEVROLET",
    "busquedas": "33786"
  },
  {
    "marca": "JEEP",
    "busquedas": "31876"
  },
  {
    "marca": "ISUZU",
    "busquedas": "19541"
  },
  {
    "marca": "PONTIAC",
    "busquedas": "11173"
  },
  {
    "marca": "BMW",
    "busquedas": "8297"
  },
  {
    "marca": "DODGE",
    "busquedas": "6548"
  },
  {
    "marca": "VOLKSWAGEN",
    "busquedas": "5861"
  },
  {
    "marca": "SUZUKI",
    "busquedas": "5221"
  },
  {
    "marca": "ACURA",
    "busquedas": "2045"
  },
  {
    "marca": "SCION",
    "busquedas": "1927"
  },
  {
    "marca": "SUBARU",
    "busquedas": "1659"
  },
  {
    "marca": "GMC",
    "busquedas": "1539"
  },
  {
    "marca": "MINI",
    "busquedas": "1522"
  },
  {
    "marca": "RAM",
    "busquedas": "1515"
  },
  {
    "marca": "MERCURY",
    "busquedas": "924"
  },
  {
    "marca": "LEXUS",
    "busquedas": "874"
  },
  {
    "marca": "MERCEDES-BENZ",
    "busquedas": "754"
  },
  {
    "marca": "VOLVO",
    "busquedas": "615"
  },
  {
    "marca": "CHRYSLER",
    "busquedas": "583"
  },
  {
    "marca": "AUDI",
    "busquedas": "479"
  },
  {
    "marca": "SATURN",
    "busquedas": "418"
  },
  {
    "marca": "HUMMER",
    "busquedas": "416"
  },
  {
    "marca": "INFINITI",
    "busquedas": "352"
  },
  {
    "marca": "GEO",
    "busquedas": "296"
  },
  {
    "marca": "PORSCHE",
    "busquedas": "219"
  },
  {
    "marca": "LAND ROVER",
    "busquedas": "214"
  },
  {
    "marca": "CADILLAC",
    "busquedas": "203"
  },
  {
    "marca": "LINCOLN",
    "busquedas": "194"
  },
  {
    "marca": "DAIHATSU",
    "busquedas": "95"
  },
  {
    "marca": "FIAT",
    "busquedas": "94"
  },
  {
    "marca": "PLYMOUTH",
    "busquedas": "76"
  },
  {
    "marca": "BUICK",
    "busquedas": "67"
  },
  {
    "marca": "JAGUAR",
    "busquedas": "54"
  },
  {
    "marca": "RENAULT",
    "busquedas": "38"
  },
  {
    "marca": "DAEWOO",
    "busquedas": "38"
  },
  {
    "marca": "JMC",
    "busquedas": "30"
  },
  {
    "marca": "JAC",
    "busquedas": "15"
  },
  {
    "marca": "MAHINDRA",
    "busquedas": "12"
  },
  {
    "marca": "FOTON",
    "busquedas": "9"
  },
  {
    "marca": "JIM",
    "busquedas": "7"
  },
  {
    "marca": "MASERATI",
    "busquedas": "6"
  },
  {
    "marca": "ZNA",
    "busquedas": "6"
  },
  {
    "marca": "PEUGEOT",
    "busquedas": "5"
  },
  {
    "marca": "CHERY",
    "busquedas": "4"
  },
  {
    "marca": "TESLA",
    "busquedas": "4"
  },
  {
    "marca": "CHANGAN",
    "busquedas": "3"
  },
  {
    "marca": "EAGLE",
    "busquedas": "2"
  },
  {
    "marca": "DATSUN",
    "busquedas": "2"
  },
  {
    "marca": "SMART",
    "busquedas": "1"
  },
  {
    "marca": "MAXUS",
    "busquedas": "1"
  },
  {
    "marca": "ASTON MARTIN",
    "busquedas": "1"
  },
  {
    "marca": "LAMBORGHINI",
    "busquedas": "1"
  }
];

export default preloadedVehiclesBrands;
